module.exports = __webpack_public_path__ + "static/media/undraw_good_team_m7uu.0b0712d9.svg";